(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    (() => {
  const normalizeArtworkFields = (root = document) => {
    root.querySelectorAll("input.gpo-file[name=\"undefined\"], input.gpo-file[data-name=\"properties[undefined]\"], input[data-field-name=\"undefined\"]").forEach((input) => {
      input.name = "properties[Artwork]";
      input.dataset.name = "properties[Artwork]";
      input.dataset.fieldName = "Artwork";
    });
  };

  normalizeArtworkFields();

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === "childList" && mutation.addedNodes.length) {
        normalizeArtworkFields();
        return;
      }

      if (mutation.type === "attributes") {
        normalizeArtworkFields(mutation.target.closest("form") || document);
        return;
      }
    }
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["name", "data-name", "data-field-name"]
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["svp-cart-property"] && !Shopify.designMode) return;
  try {
    (() => {
    let dialog, preview, message, closeButton, opener;
    document.addEventListener('click', event => {
      const trigger = event.target.closest?.('[data-svp-artwork-preview]');
      if (!trigger || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
      const thumbnail = trigger.querySelector('img');
      if (!thumbnail || thumbnail.hidden || typeof HTMLDialogElement === 'undefined') return;
      event.preventDefault();
      if (!dialog) {
        dialog = document.createElement('dialog');
        dialog.className = 'svp-artwork-dialog';
        closeButton = document.createElement('button');
        closeButton.type = 'button';
        closeButton.textContent = '×';
        preview = document.createElement('img');
        message = document.createElement('p');
        message.setAttribute('role', 'status');
        dialog.append(closeButton, preview, message);
        document.body.append(dialog);
        closeButton.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', e => {
          if (e.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) dialog.close();
        });
        dialog.addEventListener('close', () => {
          preview.removeAttribute('src');
          if (opener?.isConnected) opener.focus();
        });
        preview.addEventListener('error', () => {
          if (!dialog.open) return;
          preview.hidden = true;
          message.hidden = false;
        });
      }
      opener = trigger;
      dialog.setAttribute('aria-label', thumbnail.alt);
      closeButton.setAttribute('aria-label', trigger.dataset.closeLabel);
      preview.alt = thumbnail.alt;
      preview.hidden = false;
      message.textContent = trigger.dataset.errorLabel;
      message.hidden = true;
      preview.src = trigger.href;
      dialog.showModal();
      closeButton.focus();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["svp-qr-order-fields"] && !Shopify.designMode) return;
  try {
    (() => {
  function updateQrFields() {
    document.querySelectorAll('[data-svp-qr-fields]').forEach(fields => {
      const form = fields.querySelector('[data-svp-qr-method]').form;
      if (!form) return;
      const fromLink = fields.querySelector('[data-svp-qr-method]').value === 'Create QR code';
      const input = fields.querySelector('[data-svp-qr-url]');
      input.disabled = !fromLink;
      input.required = false;
      fields.querySelector('[data-svp-qr-platform]').disabled = !fromLink;
      fields.querySelector('[data-svp-qr-link]').hidden = !fromLink;
      const scope = form.closest('.shopify-section') || form;
      const app = scope.querySelector('.gpo-container');
      if (app && fields.nextElementSibling !== app) app.before(fields);
      scope.querySelectorAll('.gpo-dropzone').forEach(dropzone => {
        const group = dropzone.closest('.gpo-element') || dropzone;
        group.toggleAttribute('data-svp-qr-upload-hidden', fromLink);
        group.querySelectorAll('input').forEach(file => {
          if (fromLink && !file.hasAttribute('data-svp-qr-disabled')) {
            file.dataset.svpQrDisabled = String(file.disabled);
            file.disabled = true;
          } else if (!fromLink && file.hasAttribute('data-svp-qr-disabled')) {
            file.disabled = file.dataset.svpQrDisabled === 'true';
            delete file.dataset.svpQrDisabled;
          }
        });
      });
    });
  }
  document.addEventListener('change', event => {
    if (event.target.matches('[data-svp-qr-method]')) updateQrFields();
  });
  updateQrFields();
  new MutationObserver(updateQrFields).observe(document.body, {childList:true, subtree:true});
})();
  } catch(e) { console.error(e); }
})();

})();
